import { Component } from '@angular/core';

@Component({
    selector: 'app-plans-data',
    templateUrl: './plans-data.component.html',
    styleUrls: ['./plans-data.component.scss'],
    standalone: false
})
export class PlansDataComponent {
  constructor() {}
}
